import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { CounterTemplateService } from './api/counterTemplate.service';
import { GeneralService } from './api/general.service';
import { InvoiceService } from './api/invoice.service';
import { InvoicePdfService } from './api/invoicePdf.service';
import { InvoiceTemplateService } from './api/invoiceTemplate.service';
import { PeriodicInvoiceService } from './api/periodicInvoice.service';
import { PriceListService } from './api/priceList.service';

@NgModule({
  imports: [],
  declarations: [],
  exports: [],
  providers: [
    CounterTemplateService,
    GeneralService,
    InvoiceService,
    InvoicePdfService,
    InvoiceTemplateService,
    PeriodicInvoiceService,
    PriceListService,
  ],
})
export class ApiModule {
  public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [{ provide: Configuration, useFactory: configurationFactory }],
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: ApiModule, @Optional() http: HttpClient) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575',
      );
    }
  }
}
